import React, { FC } from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import { Tile } from 'components/commercetools-ui/organisms/header/types';
import useClassNames from 'helpers/hooks/useClassNames';
import { Category } from 'types/entity/category';
import HeaderDropdownTile from './header-menu-tile';

export interface Props {
  show: boolean | undefined;
  links: Category[];
  tileContent?: Tile;
  onClick?: () => void;
}

const MenuDropdown: FC<Props> = ({ show, links, tileContent, onClick }) => {
  const wrapperClassNames = useClassNames([
    'transition absolute flex justify-between bottom-0 left-0 duration-300 ease-in-out w-full translate-y-full',
    show ? 'opacity-1 z-20 delay-300' : 'opacity-0 z-[-999] pointer-events-none',
    'border-b-2 border-t-2 border-b-secondary-grey border-t-neutral-400 bg-white px-48 py-32',
  ]);

  const linksContainerClassNames = useClassNames(['grid grid-cols-[repeat(4,auto)] gap-x-32 gap-y-20 h-fit']);

  return (
    <div className={wrapperClassNames}>
      <div className={linksContainerClassNames}>
        {links?.map((link) => (
          <div key={link.categoryId} className="flex min-w-[7.5rem] max-w-[12.5rem] flex-col items-start space-y-1">
            <div>
              <Link link={link?._url} variant="menu-header" className="max-w-full">
                <Typography className="body-text-small break-words font-medium text-text-primary">
                  {link.name}
                </Typography>
              </Link>
            </div>
            <div className="grid">
              {link.descendants?.map((field) => (
                <div key={field.categoryId} onClick={onClick} className="pt-6">
                  <Link link={field?._url} variant="menu-item" className="max-w-full">
                    <Typography className="body-text-small break-words">{field.name}</Typography>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      {tileContent && <HeaderDropdownTile tileContent={tileContent} />}
    </div>
  );
};

export default MenuDropdown;
